import { createContext } from 'react';
import type { SupabaseClient } from '@supabase/supabase-js';
import type { Database } from '@/integrations/supabase/types';

export type SupabaseClientContextType = { supabase: SupabaseClient<Database> };

export const SupabaseClientContext = createContext<SupabaseClientContextType | undefined>(undefined);
